import ar from "./ar.json";
import en from "./en.json";

export default { en, ar };
